import { render, staticRenderFns } from "./CartPackagePopUp.vue?vue&type=template&id=0389accf&scoped=true"
import script from "./CartPackagePopUp.vue?vue&type=script&lang=js"
export * from "./CartPackagePopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0389accf",
  null
  
)

export default component.exports